// The ids of the boxes Baluu's booking web components put on <body> for
// the dialogs they open outside their own element (fixed positioning and
// stacking need it): each a <div> with a shadow root. One list for the
// components that create them and the pages that dress them (Website v2's
// bookingComponentCss in @baluu/puck-config, which keeps a copy pinned to
// this by its tests: its themes subpath must not import @baluu/ui).

/** Dialogs drawn with the components' shadcn variables. */
export const BOOKING_PORTAL_IDS = {
  auth: "baluu-auth-dialog-portal",
  profile: "baluu-profile-overlay-portal",
  terms: "baluu-terms-dialog-portal",
  timetableFilters: "baluu-filter-overlay-portal",
} as const;

/** The waiting list's box: the older shared Stitches dialog, always white. */
export const WAITING_LIST_PORTAL_ID = "baluu-waiting-list-portal";
